/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-18 14:44:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-02-05 11:43:59
 * @FilePath: /src/app/(payment)/payment/components/PaymentMethod/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

'use client';

import { ILoading, IUseWallet } from '@/app/(payment)/payment/ClientPage';
import Dialog from '@/components/Dialog';
import Radio from '@/components/Form/Radio';
import Image from '@/components/Image';
import AdyenPay from '@/components/Pay/AdyenPay';
import AfterPay from '@/components/Pay/AfterPay';
import AfterpayMsg from '@/components/Pay/AfterPay/AfterpayMsg';
import ApplePay from '@/components/Pay/ApplePay';
import ApplePayForOther from '@/components/Pay/ApplePayForOther';
import KlarnaMsg from '@/components/Pay/components/KlarnaMsg';
import GooglePay from '@/components/Pay/GooglePay';
import KlarnaAdyen from '@/components/Pay/KlarnaAdyen';
import KlarnaPay from '@/components/Pay/KlarnaPay';
import PayCenter from '@/components/Pay/PayCenter';
import PayPal from '@/components/Pay/PayPal';
import PaymentErrorBoundary from '@/components/Pay/PaymentErrorBoundary';
import { OrderIdNo } from '@/components/Pay/type';
import WalletPay from '@/components/Pay/WalletPay';
import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { toast } from '@/components/Toast';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { IS_DE_FR } from '@/utils/constants';
import { env } from '@/utils/env';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { accDiv, floorNumber, getDeviceTypeDetail } from '@/utils/tools';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { QuestionOutlined, SuccessFilled } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';

interface PaymentMethodProps {
  showWallet: boolean;
  walletBalance: string;
  loading: ILoading;
  setLoading: (loading: ILoading) => void;
  walletPayAmount: string;
  payAmountWithWallet: string;
  onUseWallet: (isUseWallet: IUseWallet) => void;
  allowPayment: any[];
  paypalBtn: string;
  adyenDomId: string;
  adyenDom3ds: string;
  billingAddress: any;
  shippingAddress: any;
  cartIds: any[];
  payMethods: any[];
  paymentTypeList: any[];
  isUseWallet: IUseWallet;
  grandTotal: number;
  disabled: boolean;
  userAgent: string;
  onPaypalOnClick: () => void;
  createOrders: () => Promise<any>;
  onChangePaymentMethod: (payment: string) => void;
  onPaymentPageClick: (pay_method: string) => void;
  lastPayMethod: string;
}

// klarna：根据币种得到默认的国家id
export const klarnaDefaultCountryId = {
  USD: 'US',
  EUR: 'FR',
  GBP: 'GB',
  CAD: 'CA',
};

const PaymentMethod = forwardRef<{ payAction: (order: any) => void }, PaymentMethodProps>(
  (
    {
      showWallet,
      walletBalance,
      loading,
      setLoading,
      walletPayAmount,
      payAmountWithWallet,
      onUseWallet,
      allowPayment,
      grandTotal,
      payMethods,
      shippingAddress,
      paymentTypeList,
      isUseWallet,
      adyenDomId,
      adyenDom3ds,
      billingAddress,
      cartIds,
      paypalBtn,
      createOrders,
      onChangePaymentMethod,
      disabled,
      onPaymentPageClick,
      onPaypalOnClick,
      userAgent,
      lastPayMethod,
    },
    ref,
  ) => {
    const t = useTranslations('payment.PaymentMethod');
    const globalT = useTranslations('');
    // 处理数据
    const currency = useStore((state) => state.currency);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { control } = useForm();
    const setIsGlobalLoading = useStore((state) => state.setIsGlobalLoading);

    const adyenPayRef = useRef(null);
    const payCenterRef = useRef(null);
    const klarnaPayRef = useRef(null);
    const afterpayRef = useRef(null);
    const klarnaAdyenRef = useRef(null);
    const googlePayRef = useRef(null);
    const applePayRef = useRef(null);

    const orderRef = useRef<any>(null);

    // 暴露payAction方法给父组件
    useImperativeHandle(ref, () => ({
      payAction: (_order: any) => {
        payAction(_order);
      },
    }));

    const [applepayValid, setApplepayValid] = useState(false);
    const [googlepayValid, setGooglepayValid] = useState(false);
    const [showKlarnaDialog, setShowKlarnaDialog] = useState(false);
    const [adyenDialog, setAdyenDialog] = useState(false);
    const [googlePayDialog, setGooglePayDialog] = useState(false);
    const [eventPaymentMethod, setEventPaymentMethod] = useState('');

    const handleChangePaymentMethod = (item: string) => {
      setEventPaymentMethod(item);
    };

    const isThirdApp = () => {
      const ret = getDeviceTypeDetail(userAgent.toLowerCase());
      return ret.isFaceBook || ret.isInstagram || ret.isTikTok;
    };

    const stages = useMemo(() => {
      let _price = grandTotal;
      if (isUseWallet === IUseWallet.USE && !disabled) {
        _price = parseFloat(payAmountWithWallet);
      }
      if (!_price || isNaN(_price) || _price <= 0) {
        return '0.00';
      }
      try {
        return floorNumber(accDiv(_price, 4));
      } catch (error) {
        logger.error('Error calculating stages:', error);
        return '0.00';
      }
    }, [grandTotal, isUseWallet, disabled, payAmountWithWallet]);

    const klarnaEssentialInfo = useMemo(() => {
      let countryId = '';
      if (shippingAddress?.id) {
        countryId = shippingAddress?.country_id;
      } else {
        // 无运输地址则根据币种取默认的国家id。目的是在无地址时显示出来klarna支付方式，且分期金额和金额限制正确
        countryId = klarnaDefaultCountryId[currency.name] || '';
      }
      const klarnaItem = paymentTypeList.find((item) => item.payment_method === 'klarna') || {};
      const allSupported = klarnaItem?.extended_field?.klarna_supported || {};
      return allSupported?.[countryId]?.find((item) => item.currency === currency.name) || {};
    }, [paymentTypeList, shippingAddress?.country_id]);

    const klarnaPrice = useMemo(() => {
      let _price = grandTotal;
      if (isUseWallet === IUseWallet.USE && !disabled) {
        _price = parseFloat(payAmountWithWallet);
      }
      return floorNumber(accDiv(_price, klarnaEssentialInfo?.cycle || 4));
    }, [grandTotal, isUseWallet, disabled, payAmountWithWallet, klarnaEssentialInfo]);

    const isShowKlarna = useMemo(() => {
      const rule1 = klarnaEssentialInfo?.currency === currency.name;
      // 如果使用了电子钱包，那么支付的金额按照使用电子钱包之后需要支付的金额计算
      const _price =
        isUseWallet === IUseWallet.USE && parseFloat(payAmountWithWallet) > 0
          ? parseFloat(payAmountWithWallet)
          : grandTotal;
      const rule2 = _price >= klarnaEssentialInfo?.min;
      const rule3 = _price <= klarnaEssentialInfo?.max;
      const klarnaItem =
        paymentTypeList.find(
          (item) => item.payment_method === 'klarna' && item.payment_channel === 'klarna',
        )?.extended_field.klarna_supported || {};
      const rule4 = !!klarnaItem[shippingAddress?.country_id]?.some(
        (item) => item.currency === currency.name,
      );

      return rule1 && rule2 && rule3 && rule4;
    }, [
      payMethods,
      paymentTypeList,
      shippingAddress?.country_id,
      klarnaEssentialInfo,
      payAmountWithWallet,
      grandTotal,
    ]);

    const isShowAfterpay = useMemo(() => {
      // 美国+USD，加拿大+CAD，澳大利亚+AUD
      // 10-1000 美元
      // billing地址的"country"和shipping地址的"country"一致
      // 无地址时判断当前币种是否支持
      const afterpayEssentialMap = {
        AUD: 'AU',
        CAD: 'CA',
        USD: 'US',
      };
      const _price =
        isUseWallet === IUseWallet.USE && parseFloat(payAmountWithWallet) > 0
          ? parseFloat(payAmountWithWallet)
          : grandTotal;

      const rule1 = _price >= 10 && _price <= 1000;
      let rule2 = false;
      if (shippingAddress?.country_id) {
        rule2 = afterpayEssentialMap[currency.name] === shippingAddress?.country_id;
      } else {
        rule2 = !!afterpayEssentialMap[currency.name];
      }
      return rule1 && rule2;
    }, [payMethods, payAmountWithWallet, grandTotal, shippingAddress?.country_id]);

    const isShowKlarnaAdyen = useMemo(() => {
      const rule1 = klarnaEssentialInfo?.currency === currency.name;
      // 如果使用了电子钱包，那么支付的金额按照使用电子钱包之后需要支付的金额计算
      const _price =
        isUseWallet === IUseWallet.USE && parseFloat(payAmountWithWallet) > 0
          ? parseFloat(payAmountWithWallet)
          : grandTotal;

      const rule2 = _price >= klarnaEssentialInfo?.min;
      const rule3 = _price <= klarnaEssentialInfo?.max;
      const klarnaItem =
        paymentTypeList.find(
          (item) => item.payment_method === 'klarna' && item.payment_channel === 'adyen',
        )?.extended_field.klarna_supported || {};
      const rule4 = !!klarnaItem[shippingAddress?.country_id]?.some(
        (item) => item.currency === currency.name,
      );

      return rule1 && rule2 && rule3 && rule4;
    }, [
      payMethods,
      payAmountWithWallet,
      paymentTypeList,
      shippingAddress?.country_id,
      klarnaEssentialInfo,
      grandTotal,
    ]);

    const currPayMethods = useMemo(() => {
      const _pmds = [...payMethods];

      if (!isShowKlarna && !isShowKlarnaAdyen) {
        const index = _pmds.indexOf('klarna');
        index > -1 && _pmds.splice(index, 1);
      }

      if (!isShowAfterpay) {
        const index = _pmds.indexOf('afterpay');
        index > -1 && _pmds.splice(index, 1);
      }

      if (isThirdApp() || !googlepayValid) {
        const index = _pmds.indexOf('googlepay');
        index > -1 && _pmds.splice(index, 1);
      }

      if (!applepayValid) {
        const index = _pmds.indexOf('applepay');
        index > -1 && _pmds.splice(index, 1);
      }

      return _pmds;
    }, [
      payMethods,
      isShowAfterpay,
      isShowKlarna,
      isShowKlarnaAdyen,
      applepayValid,
      googlepayValid,
    ]);

    const paymentAvailability = useMemo(() => {
      return {
        klarna: isShowKlarna || isShowKlarnaAdyen,
        afterpay: isShowAfterpay,
        googlepay: !isThirdApp() && googlepayValid,
        applepay: applepayValid,
      };
    }, [
      isShowKlarna,
      isShowKlarnaAdyen,
      isShowAfterpay,
      isThirdApp,
      googlepayValid,
      applepayValid,
    ]);

    const paymentMethod = useMemo(() => {
      // 默认
      let payment = '';
      if (disabled) {
        // 全部使用钱包
        payment = '';
      } else if (eventPaymentMethod) {
        // 用户选择的支付方式
        payment = eventPaymentMethod;
      } else if (lastPayMethod) {
        // 记录的最后一次的支付方式
        payment = lastPayMethod;
      }

      // 如果指定的支付方式存在于映射中且不可用，则直接返回
      if (payment in paymentAvailability && !paymentAvailability[payment]) {
        return '';
      }
      return payment;
    }, [disabled, eventPaymentMethod, lastPayMethod, paymentAvailability]);

    useEffect(() => {
      onChangePaymentMethod(paymentMethod);
    }, [paymentMethod]);

    const isShowOtherPaymentMethod = useMemo(() => {
      // 为了逻辑清晰，先判断是否存在其他支付方式
      // 移动端和pc端的通用条件：
      const universalRule = currPayMethods.length > 0 && allowPayment.length > 0;

      // 如果是移动端,且全额用了电子钱包支付，则剩下的支付方式就隐藏掉
      if (isMobile && disabled && universalRule) {
        return false;
      }

      // pc端相对应的只需要对其他支付方式禁用处理
      if (!isMobile && !universalRule) {
        return false;
      }

      return true;
    }, [currPayMethods, allowPayment, isMobile, disabled]);

    const isShowAdyenCard = useMemo(() => {
      return paymentTypeList.some(
        (item) => item.payment_method === 'card' && item.payment_channel === 'adyen',
      );
    }, [paymentTypeList]);

    const isShowPayCenter = useMemo(() => {
      return paymentTypeList.some(
        (item) => item.payment_method === 'card' && item.payment_channel === 'pay_center',
      );
    }, [paymentTypeList]);

    const totalPrice = useMemo(() => {
      return isUseWallet === IUseWallet.USE && parseFloat(payAmountWithWallet) > 0
        ? payAmountWithWallet
        : grandTotal;
    }, [isUseWallet, payAmountWithWallet, grandTotal]);

    const payAction = (_order: any) => {
      if (_order) {
        orderRef.current = _order;
      }
      if (paymentMethod === 'card' && isShowAdyenCard && adyenPayRef.current) {
        setAdyenDialog(true);
        adyenPayRef.current.payAction(_order);
      } else if (paymentMethod === 'card' && isShowPayCenter && payCenterRef.current) {
        payCenterRef.current.payAction(_order);
      } else if (paymentMethod === 'klarna' && isShowKlarna && klarnaPayRef.current) {
        klarnaPayRef.current.payAction(_order);
      } else if (paymentMethod === 'klarna' && isShowKlarnaAdyen && klarnaAdyenRef.current) {
        klarnaAdyenRef.current.payAction(_order);
      } else if (paymentMethod === 'afterpay' && afterpayRef.current) {
        afterpayRef.current.payAction(_order);
      } else if (paymentMethod === 'googlepay' && googlePayRef.current) {
        setGooglePayDialog(true);
        setTimeout(() => {
          if (window?.google?.payments) {
            googlePayRef.current.payAction(true, _order);
          } else {
            let attempts = 0;
            const maxAttempts = 20; // 最多等待10秒 (20 * 500ms)
            const timer = setInterval(() => {
              attempts++;
              if (window?.google?.payments) {
                clearInterval(timer);
                googlePayRef.current.payAction(true, _order);
              } else if (attempts >= maxAttempts) {
                clearInterval(timer);
                logger.error('Google Pay script load timeout after 10 seconds');
                payFail(t('googlePayNotAvailable'));
              }
            }, 500);
          }
        }, 10);
      } else if (paymentMethod === 'applepay' && applePayRef.current) {
        logger.log('打印-1 applePayRef.current', applePayRef.current);
        logger.log('打印-2 _order', _order);
        applePayRef.current.payAction(true, _order);
      }
    };

    const paySuccess = (order?: any) => {
      sessionStorage.setItem('zl-payFlag', '1');

      const order_id = orderRef.current?.order_id || order?.order_id || '';
      const order_no = orderRef.current?.order_no || order?.order_no || '';

      if (!order_id || !order_no) {
        return;
      }

      logger.log('order_id', order_id);
      logger.log('order_no', order_no);

      logger.log('支付成功，准备跳转支付成功页面 --->order', orderRef.current);

      location.href = `/paymentSuccess?order_id=${order_id}&order_no=${order_no}`;
    };

    const payFail = (msg?: any, order?: any) => {
      logger.log('支付失败，准备跳转支付失败页面 --->msg', msg);

      const order_id = msg?.order_id || orderRef.current?.order_id || order?.order_id || '';
      const order_no = msg?.order_no || orderRef.current?.order_no || order?.order_no || '';

      if (!order_id || !order_no) {
        setLoading({
          ...loading,
          placeOrder: false,
        });
        return;
      }

      logger.log('order_id', order_id);
      logger.log('order_no', order_no);

      if (msg) {
        toast.error(msg);
        setTimeout(() => {
          setIsGlobalLoading(true);
          location.href = `/account/my-orders/order-detail/${order_id}?order_no=${order_no}`;
        }, 3000);
        return;
      }
      setIsGlobalLoading(true);
      location.href = `/account/my-orders/order-detail/${order_id}?order_no=${order_no}`;
    };

    const onlyPayFail = (orderInfo: OrderIdNo, msg?: string) => {
      logger.log('onlyPayFail--支付失败，准备跳转支付失败页面 --->msg', msg);

      const jumpHref =
        orderInfo?.order_id && orderInfo?.order_no
          ? `/account/my-orders/order-detail/${orderInfo.order_id}?order_no=${orderInfo.order_no}`
          : '/account/my-orders?status=1';
      logger.log('onlyPayFail--jumpHref', jumpHref, orderInfo);

      if (msg) {
        toast.error(msg);
        setTimeout(() => {
          setIsGlobalLoading(true);
          location.href = jumpHref;
        }, 3000);
        return;
      }

      setIsGlobalLoading(true);
      location.href = jumpHref;
    };

    const renderLabel = (item: string) => {
      return (
        <div className="w-full h-full md:ml-[16px]">
          {item === 'paypal' && (
            <PayPal
              domId={paypalBtn}
              from="payment"
              createOrder={createOrders}
              order={orderRef.current}
              height={isMobile ? 40 : 55}
              onSuccess={paySuccess}
              onError={payFail}
              onPaypalOnClick={onPaypalOnClick}
            >
              <div className="flex items-center">
                <div className=" w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                  <Image src="/payment/paypal.png" alt="" width={60} height={40} />
                </div>
                <div className="">
                  <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                    PayPal
                  </div>
                </div>
              </div>
            </PayPal>
          )}

          {item === 'card' && isShowAdyenCard && (
            <AdyenPay
              ref={adyenPayRef}
              order={orderRef.current}
              adyenDomId={adyenDomId}
              adyenDom3ds={adyenDom3ds}
              paySuccess={paySuccess}
              payFail={payFail}
            >
              <div className="flex items-center ">
                <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                  <Image
                    src="/payment/credit.png"
                    alt=""
                    width={60}
                    height={40}
                    className="w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
                  />
                </div>
                <div className="">
                  <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                    {globalT('priceDifference.creditDebitCard')}
                  </div>
                  <Image
                    className="mt-0 md:mt-[8px]"
                    src="/payment/debot_card.png"
                    alt=""
                    width={194}
                    height={18}
                  />
                </div>
              </div>
            </AdyenPay>
          )}

          {item === 'card' && isShowPayCenter && (
            <div>
              <PayCenter
                ref={payCenterRef}
                totalPrice={totalPrice.toString()}
                symbol_prefix={currency.symbol_prefix}
                symbol_suffix={currency.symbol_suffix}
                currency={currency.full_symbol}
                from="payment"
                onSuccess={paySuccess}
                onError={payFail}
              >
                <div className="flex items-center">
                  <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                    <Image
                      src="/payment/credit.png"
                      alt=""
                      width={60}
                      height={40}
                      className="w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
                    />
                  </div>
                  <div className="">
                    <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                      {globalT('priceDifference.creditDebitCard')}
                    </div>
                    <Image
                      className="mt-[4px] md:mt-[8px]"
                      src="/payment/debot_card.png"
                      alt=""
                      width={194}
                      height={18}
                    />
                  </div>
                </div>
              </PayCenter>
            </div>
          )}

          {item === 'afterpay' && (
            <AfterPay ref={afterpayRef} onError={payFail}>
              <div className="flex items-center">
                <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                  <Image
                    src="/payment/afterpay.png"
                    alt=""
                    width={60}
                    height={40}
                    className="w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
                  />
                </div>
                <div className="">
                  <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                    Afterpay
                  </div>
                  <div className="text-[12px] md:text-[14px] text-auxiliary-text mt-[1px]">
                    {typeof stages === 'string' && (
                      <AfterpayMsg afterpayPrice={stages} currency={currency} />
                    )}
                  </div>
                </div>
              </div>
            </AfterPay>
          )}

          {item === 'klarna' && isShowKlarna && (
            <KlarnaPay
              ref={klarnaPayRef}
              order={orderRef.current}
              from="payment"
              billingAddress={billingAddress}
              shippingAddress={shippingAddress}
              currPayMethod={paymentMethod}
              cartIds={cartIds}
              paySuccess={paySuccess}
              payFail={payFail}
            >
              <div className="flex items-center">
                <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                  <Image
                    src="/payment/klarna.png"
                    alt=""
                    width={60}
                    height={40}
                    className="w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
                  />
                </div>
                <div className="">
                  <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                    Klarna
                  </div>
                  {!IS_DE_FR ? (
                    <div className="text-[12px] md:text-[14px] text-auxiliary-text mt-[1px]">
                      {klarnaEssentialInfo.cycle} {t('interestFreePaymentsOf')}{' '}
                      <span className="notranslate">
                        {formatPriceNumberWithSymbol(klarnaPrice, currency)}
                      </span>
                      <QuestionOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setShowKlarnaDialog(true);
                        }}
                        className="inline-block text-14 ml-4 cursor-pointer"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </KlarnaPay>
          )}

          {item === 'klarna' && isShowKlarnaAdyen && (
            <KlarnaAdyen
              ref={klarnaAdyenRef}
              klarnaEssentialInfo={klarnaEssentialInfo}
              payFail={payFail}
              paySuccess={paySuccess}
            >
              <div className="flex items-center">
                <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                  <Image
                    src="/payment/klarna.png"
                    alt=""
                    width={60}
                    height={40}
                    className="w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
                  />
                </div>
                <div className="">
                  <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                    Klarna
                  </div>
                  {!IS_DE_FR ? (
                    <div className="text-[12px] md:text-[14px] text-auxiliary-text mt-[1px]">
                      {klarnaEssentialInfo.cycle} {t('interestFreePaymentsOf')}{' '}
                      <span className="notranslate">
                        {formatPriceNumberWithSymbol(klarnaPrice, currency)}
                      </span>
                      <QuestionOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setShowKlarnaDialog(true);
                        }}
                        className="inline-block text-14 ml-4 cursor-pointer"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </KlarnaAdyen>
          )}

          {item === 'googlepay' && isMobile && (
            <div className="flex items-center">
              <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                <Image
                  src="/payment/GPay_Acceptance_Mark_800.png"
                  alt=""
                  width={60}
                  height={40}
                  className="w-[38px] md:w-[60px] h-fit md:h-[40px] max-w-[60px] m-h-[40px]"
                />
              </div>
              <div className="">
                <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                  Google Pay
                </div>
              </div>
            </div>
          )}

          {item === 'applepay' && isMobile && (
            <div className="flex items-center">
              <div className="w-[38px] md:w-[60px] h-fit md:h-[40px] mr-[10px] md:mr-[18px]">
                <Image src="/payment/applepay.png" alt="" width={60} height={40} />
              </div>
              <div className="">
                <div className="text-primary text-[14px] md:text-base leading-[14px] font-bs">
                  Apple Pay
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    return (
      <div>
        <div className="font-bb mb-16 text-[16px] md:text-[18px]">{t('paymentMethod')}</div>
        {showWallet && (
          <WalletPay
            walletBalance={walletBalance}
            walletPayAmount={walletPayAmount}
            payAmountWithWallet={payAmountWithWallet}
            loading={loading.priceLoading}
            onChange={onUseWallet}
            isMobile={isMobile}
          />
        )}

        {/* 根据条件判断当全额使用电子钱包支付时，其他支付条件在pc和移动上的展示逻辑是不同的，pc上禁用，wap上隐藏 */}
        {isShowOtherPaymentMethod && (
          <>
            <div className="flex  flex-col md:gap-16">
              {currPayMethods.length > 0 &&
                currPayMethods.map((item) => (
                  <PaymentErrorBoundary key={item} paymentType={item}>
                    <div
                      className={` ${paymentMethod === item ? 'bg-[#e3ebff] border-1 md:border-2 !rounded-10 border-[#463ae8]' : 'border-t-1 md:border-1 border-[#ccc]'} rounded-none md:rounded-10 `}
                    >
                      <Radio
                        name="paymentMethod"
                        value={item}
                        control={control}
                        label={renderLabel(item)}
                        labelPlacement={isMobile ? 'start' : 'end'}
                        onChange={() => {
                          handleChangePaymentMethod(item);
                          onPaymentPageClick(item);
                        }}
                        disabled={disabled}
                        checked={paymentMethod === item}
                        iconSize={20}
                        checkedIcon={<SuccessFilled className="text-[20px] text-[#463AE8]" />}
                        sx={{
                          width: '100%',
                          margin: 0,

                          padding: isMobile ? '16px 6px' : '16px 20px',
                          '& .MuiFormControlLabel-label': {
                            width: '100%',
                            flexGrow: 1,
                            minHeight: '33px',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          },
                          ...(!isMobile && {
                            '& .MuiRadio-root': {
                              padding: 0,
                            },
                          }),
                          // 移动端 Radio 按钮尺寸设置为34px
                          ...(isMobile && {
                            '& .MuiRadio-root': {
                              width: '20px',
                              height: '20px',
                              padding: 0,
                            },
                          }),
                        }}
                      />
                    </div>
                  </PaymentErrorBoundary>
                ))}
              <WebOnly>
                <Dialog
                  open={adyenDialog}
                  onClose={(_, reason) => {
                    if (reason !== 'backdropClick') {
                      setAdyenDialog(false);
                      payFail();
                    }
                  }}
                  title="Payment"
                  footer={null}
                >
                  <div id="adyen-container" />
                  <div id="adyen-container-3ds" />
                </Dialog>
              </WebOnly>

              <WapOnly>
                <Popup
                  open={adyenDialog}
                  onClose={() => {
                    setAdyenDialog(false);
                    payFail();
                  }}
                  title="Payment"
                  height="50vh"
                  position="bottom"
                  closeOnClickOverlay={false}
                >
                  <div id="adyen-container" />
                  <div id="adyen-container-3ds" />
                </Popup>
                <Dialog
                  open={googlePayDialog}
                  onClose={() => {
                    setGooglePayDialog(false);
                    payFail();
                  }}
                  showCloseIcon={false}
                  closeOnClickOverlay={false}
                  footer={null}
                >
                  <div className="w-full flex justify-center items-center mb-30">
                    <Image
                      className="pay-logo"
                      src="/payment/GPay_Acceptance_Mark_800.png"
                      alt=""
                      width={80}
                      height={80}
                    />
                  </div>
                  <div id="google-pay-container" className="flex justify-center items-center" />
                  <div id="google-pay-3ds-container" />
                </Dialog>
              </WapOnly>
            </div>

            <KlarnaMsg
              price={klarnaPrice}
              show={showKlarnaDialog}
              currency={currency}
              klarnaEssentialInfo={klarnaEssentialInfo}
              onCloseKlarnaMsg={() => setShowKlarnaDialog(false)}
            />

            <WapOnly>
              <PaymentErrorBoundary paymentType="googlepay">
                <GooglePay
                  ref={googlePayRef}
                  from="payment"
                  createOrder={createOrders}
                  grandTotal={grandTotal}
                  shipping={shippingAddress}
                  isUseWallet={isUseWallet}
                  googlePayDomId={'#google-pay-container'}
                  googlePayDom3ds={'#google-pay-3ds-container'}
                  payAmountWithWallet={payAmountWithWallet}
                  onPaySuccess={(data) => {
                    paySuccess(data);
                  }}
                  onPayFail={(orderInfo) => {
                    onlyPayFail(orderInfo);
                  }}
                  onValid={(valid) => {
                    setGooglepayValid(valid);
                  }}
                />
              </PaymentErrorBoundary>

              <PaymentErrorBoundary paymentType="applepay">
                {env.NEXT_PUBLIC_SITE_NAME === 'us' ? (
                  <ApplePay
                    ref={applePayRef}
                    from="payment"
                    createOrder={createOrders}
                    grandTotal={grandTotal}
                    shipping={shippingAddress}
                    isUseWallet={isUseWallet}
                    payAmountWithWallet={payAmountWithWallet}
                    onPaySuccess={(data) => {
                      paySuccess(data);
                    }}
                    onPayFail={(orderInfo) => {
                      onlyPayFail(orderInfo);
                    }}
                    onValid={(valid) => {
                      setApplepayValid(valid);
                    }}
                  />
                ) : (
                  <ApplePayForOther
                    ref={applePayRef}
                    from="payment"
                    createOrder={createOrders}
                    grandTotal={grandTotal}
                    shipping={shippingAddress}
                    isUseWallet={isUseWallet}
                    payAmountWithWallet={payAmountWithWallet}
                    onPaySuccess={(data) => {
                      paySuccess(data);
                    }}
                    onPayFail={(orderInfo) => {
                      onlyPayFail(orderInfo);
                    }}
                    onValid={(valid) => {
                      setApplepayValid(valid);
                    }}
                  />
                )}
              </PaymentErrorBoundary>
            </WapOnly>
          </>
        )}
      </div>
    );
  },
);

PaymentMethod.displayName = 'PaymentMethod';

export default PaymentMethod;
